import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
export function WhyOldFails() {
  return <section className="py-20 bg-white" data-id="element-150">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl" data-id="element-151">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-152">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-navy-900 mb-6" data-id="element-153">
            Why what you've tried hasn't worked
          </h2>
          <p className="text-lg text-gray-600" data-id="element-154">
            Most "help" falls into one of these traps:
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-155">
          {[{
          title: 'Disordered Info',
          desc: 'Leaves you the same, but with more browser tabs open.'
        }, {
          title: 'High-Energy Advice',
          desc: "Requires energy you don't have (when you're already in the red)."
        }, {
          title: 'Generic Solutions',
          desc: "Doesn't land for your specific, real-life case."
        }].map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-gray-50 p-6 rounded-xl text-center" data-id="element-156">
              <div className="inline-flex items-center justify-center h-10 w-10 rounded-full bg-red-100 text-red-500 mb-4" data-id="element-157">
                <AlertCircle className="h-5 w-5" data-id="element-158" />
              </div>
              <h3 className="font-bold text-navy-900 mb-2" data-id="element-159">{item.title}</h3>
              <p className="text-sm text-gray-600" data-id="element-160">{item.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-12 text-center" data-id="element-161">
          <p className="text-lg md:text-xl text-navy-900 font-medium" data-id="element-162">
            This system was designed for a real mum on a real day: <br data-id="element-163" />
            <span className="text-teal-600 font-serif italic" data-id="element-164">
              when you can only do one thing, but that thing has to be the right
              one.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}